export class Usuario {
  id: string;
  nombresCompletos: string;
  dni: string;
  codigoAeroplanta: string;
  rol: string;

  _bloquear: boolean
}